{
  "id": "beef-jerky",
  "slug": "beef-jerky",
  "name": "Beef Jerky Recipes",
  "title": "Beef Jerky Recipes",
  "category": "other",
  "subcategory": "cured-meats",
  "tags": ["beef", "jerky", "smoked", "cured", "snack", "protein"],
  "description": "Three amazing beef jerky recipes: Simple, Teriyaki, and Sweet & Spicy. All scaled to 2 lbs of meat. Store-bought jerky is expensive and full of preservatives - make your own with real ingredients and authentic smoke flavor.",
  "difficulty": "intermediate",
  "prepTime": "30 minutes",
  "activeTime": "45 minutes",
  "totalTime": "10-18 hours (includes marinating + smoking)",
  "servings": "2 lbs beef (makes ~1 lb jerky)",
  "author": "Jonny",
  "datePublished": "2025-02-06",
  "featuredImage": "media/tiktok_7538254423655550238.png",
  "postEmbedGroupCodes": ["sweet-and-spicy-beef-jerky-recipe", "homemade-smoked-beef-jerky-guide"],
  "gallerySearchTerm": "jerky",
  "blogPostUrl": "/blog/jerky",
  "equipment": [
    "Sharp knife or meat slicer",
    "Mixing bowls",
    "Gallon ziplock bags or vacuum sealer",
    "Wire racks",
    "Smoker",
    "Weber Smokey Mountain",
    "Weber Searwood",
    "Dehydrator (optional)"
  ],
  "variants": [
    {
      "variantId": "simple-jerky",
      "name": "Simple Jerky Recipe",
      "description": "Classic tried-and-true recipe with minimal ingredients. Perfect for beginners.",
      "featured": true,
      "ingredients": [
        {
          "item": "Eye of round or top round beef",
          "amount": "2",
          "unit": "lb",
          "notes": "trimmed of fat"
        },
        {
          "item": "Soy Sauce",
          "amount": "3/4",
          "unit": "cup"
        },
        {
          "item": "Worcestershire Sauce",
          "amount": "1/4",
          "unit": "cup"
        },
        {
          "item": "Brown Sugar",
          "amount": "1",
          "unit": "tbsp"
        },
        {
          "item": "Black Pepper",
          "amount": "1",
          "unit": "tsp"
        },
        {
          "item": "Garlic Powder",
          "amount": "1",
          "unit": "tsp"
        },
        {
          "item": "Onion Powder",
          "amount": "1",
          "unit": "tsp"
        },
        {
          "item": "Red Pepper Flakes",
          "amount": "1/2",
          "unit": "tsp"
        },
        {
          "item": "Liquid Smoke",
          "amount": "1",
          "unit": "tsp",
          "notes": "ONLY if using a dehydrator - omit if smoking. We prefer real smoke!"
        }
      ]
    },
    {
      "variantId": "teriyaki-jerky",
      "name": "Teriyaki Jerky Recipe",
      "description": "Asian-inspired with sesame oil, ginger, and coriander. More complex flavor profile.",
      "ingredients": [
        {
          "item": "Eye of round or top round beef",
          "amount": "2",
          "unit": "lb",
          "notes": "trimmed of fat"
        },
        {
          "item": "Soy Sauce",
          "amount": "1/2",
          "unit": "cup"
        },
        {
          "item": "Worcestershire Sauce",
          "amount": "1/4",
          "unit": "cup"
        },
        {
          "item": "Sesame Oil",
          "amount": "2",
          "unit": "tsp"
        },
        {
          "item": "Honey",
          "amount": "1",
          "unit": "tbsp"
        },
        {
          "item": "Dark Brown Sugar",
          "amount": "1",
          "unit": "tbsp"
        },
        {
          "item": "Smoked Paprika",
          "amount": "2",
          "unit": "tsp"
        },
        {
          "item": "Onion Powder",
          "amount": "1",
          "unit": "tsp"
        },
        {
          "item": "Garlic Powder",
          "amount": "1",
          "unit": "tsp"
        },
        {
          "item": "Black Pepper",
          "amount": "1",
          "unit": "tsp"
        },
        {
          "item": "Red Pepper Flakes",
          "amount": "1/2",
          "unit": "tsp"
        },
        {
          "item": "Cayenne Pepper",
          "amount": "1/2",
          "unit": "tsp"
        },
        {
          "item": "Ground Coriander",
          "amount": "1/2",
          "unit": "tsp"
        },
        {
          "item": "Ground Ginger",
          "amount": "1/2",
          "unit": "tsp"
        },
        {
          "item": "Liquid Smoke",
          "amount": "1",
          "unit": "tsp",
          "notes": "ONLY if using a dehydrator - omit if smoking. We prefer real smoke!"
        }
      ]
    },
    {
      "variantId": "sweet-spicy-jerky",
      "name": "Sweet & Spicy Jerky Recipe",
      "description": "Bold and fruity with habanero heat and citrus brightness. Adapted from @stellanspice.",
      "notes": "Scaled down from original 10 lb recipe to 2 lbs. Pepper blend uses 1 habanero + 1 jalapeño instead of original 5 habaneros.",
      "ingredients": [
        {
          "item": "Eye of round or top round beef",
          "amount": "2",
          "unit": "lb",
          "notes": "trimmed of fat"
        },
        {
          "item": "Low sodium soy sauce",
          "amount": "1/3",
          "unit": "cup"
        },
        {
          "item": "Brown sugar",
          "amount": "1/3",
          "unit": "cup"
        },
        {
          "item": "Worcestershire sauce",
          "amount": "2",
          "unit": "tbsp"
        },
        {
          "item": "Balsamic vinegar",
          "amount": "2",
          "unit": "tbsp"
        },
        {
          "item": "Fresh orange juice",
          "amount": "2",
          "unit": "tbsp"
        },
        {
          "item": "Fresh grapefruit juice",
          "amount": "2",
          "unit": "tbsp"
        },
        {
          "item": "Crushed red pepper",
          "amount": "1 1/4",
          "unit": "tsp"
        },
        {
          "item": "Onion powder",
          "amount": "1 1/4",
          "unit": "tsp"
        },
        {
          "item": "Garlic powder",
          "amount": "1 1/4",
          "unit": "tsp"
        },
        {
          "item": "Black pepper",
          "amount": "3/4",
          "unit": "tsp"
        },
        {
          "item": "Habanero pepper",
          "amount": "1/2",
          "notes": "fresh, finely chopped"
        },
        {
          "item": "Jalapeño pepper",
          "amount": "1/2",
          "notes": "fresh, finely chopped"
        },
        {
          "item": "Liquid Smoke",
          "amount": "1",
          "unit": "tsp",
          "notes": "ONLY if using a dehydrator - omit if smoking. We prefer real smoke!"
        }
      ]
    }
  ],
  "instructions": [
    {
      "step": 1,
      "title": "Choose and freeze the beef",
      "description": "Start with a lean cut of beef like eye of round, top round, bottom round, or brisket flat. Put in freezer for 1 hour - partially frozen beef is much easier to trim and slice.",
      "tips": [
        "Look for beef around $5/lb at your grocery store",
        "Leaner cuts work better - fat doesn't dehydrate well",
        "Freezing for exactly 1 hour gives the perfect firmness for slicing"
      ]
    },
    {
      "step": 2,
      "title": "Trim and slice the beef",
      "description": "Trim off all surface fat. Using a sharp knife or meat slicer, cut against the grain into 1/4 inch thick slices. Then cut those slices into strips.",
      "tips": [
        "Cutting against the grain makes jerky easier to bite and chew",
        "Consistent 1/4 inch thickness ensures even drying",
        "A meat slicer makes this much easier and faster"
      ]
    },
    {
      "step": 3,
      "title": "Mix the marinade",
      "description": "Choose one of the three marinade recipes using the calculator above. Whisk all marinade ingredients together in a large bowl until well combined. The calculator scales ingredients based on your beef weight.",
      "tips": [
        "No salt needed - soy sauce and Worcestershire have plenty of sodium",
        "Never add liquid smoke - real smoke flavor is infinitely better",
        "Mix thoroughly to dissolve sugar completely",
        "The calculator above automatically scales all marinade ingredients"
      ]
    },
    {
      "step": 4,
      "title": "Marinate the beef",
      "description": "Add beef strips to the marinade, making sure all sides are well coated. Refrigerate for 6-16 hours. Flip or massage the bag every few hours to distribute marinade evenly.",
      "duration": "6-16 hours",
      "tips": [
        "Vacuum sealing helps marinade penetrate better",
        "16 hours gives maximum flavor, 6 hours is minimum",
        "Use gallon ziplock bags if you don't have a vacuum sealer"
      ]
    },
    {
      "step": 5,
      "title": "Prepare for smoking",
      "description": "Remove beef from marinade and lay out pieces on wire racks. You can pat them down with paper towels, but leaving the marinade on adds more flavor. Optionally add extra black pepper.",
      "tips": [
        "Don't rinse - you want that marinade flavor",
        "Separate pieces so they don't touch",
        "Extra black pepper on top adds nice crust"
      ]
    },
    {
      "step": 6,
      "title": "Smoke the jerky",
      "description": "Smoke at 180°F (82°C) for about 4 hours until jerky has a nice dark color and bends without breaking. If using a dehydrator: smoke for 2 hours at 180°F (82°C), then finish in dehydrator at 150°F (65°C) for 2-4 hours.",
      "duration": "4 hours",
      "temperature": "180°F (82°C)",
      "tips": [
        "Perfect jerky bends but doesn't snap in half",
        "Dark mahogany color indicates it's done",
        "Dehydrator method gives more consistent results",
        "Use hickory, mesquite, or any hardwood for smoking"
      ]
    },
    {
      "step": 7,
      "title": "Cool and store",
      "description": "Let jerky cool completely at room temperature. Store in refrigerator in airtight container or ziplock bags.",
      "tips": [
        "Eat within a few days without curing salt",
        "Keeps 1-2 weeks in fridge",
        "Can freeze for up to 6 months",
        "No preservatives needed when refrigerated"
      ]
    }
  ],
  "sharedNotes": "All recipes scaled to 2 lbs of meat unless otherwise noted. No curing salt (Prague Powder #1) is used in these recipes because they're stored in the fridge and eaten within days. Liquid smoke is included as an option for dehydrator users, but we strongly prefer real smoke flavor - it's infinitely better!",
  "tips": [
    "Don't have a smoker? After marinating, use a dehydrator at 150°F (65°C) for 4-6 hours",
    "For spicier jerky, add more red pepper flakes or cayenne to any recipe",
    "Experiment with different wood chips: hickory, mesquite, apple, or cherry",
    "Save money: homemade jerky costs ~$5/lb vs $20-30/lb store-bought"
  ],
  "relatedRecipes": ["bacon"],
  "tool": {
    "id": "jerky",
    "name": "Jerky Calculator",
    "description": "Calculate marinade ingredients for any amount of beef",
    "presetId": "simple-jerky"
  },
  "printMode": {
    "title": "Beef Jerky Recipes",
    "servings": "2 lbs beef (makes ~1 lb jerky)",
    "totalTime": "10-18 hours (includes marinating + smoking)",
    "difficulty": "intermediate",
    "variants": [
      {
        "variantId": "simple-jerky",
        "name": "Simple Jerky Recipe",
        "ingredients": [
          {
            "item": "Eye of round or top round beef",
            "amount": "2",
            "unit": "lb",
            "notes": "907g, trimmed of fat"
          },
          {
            "item": "Soy Sauce",
            "amount": "3/4",
            "unit": "cup",
            "notes": "180ml"
          },
          {
            "item": "Worcestershire Sauce",
            "amount": "1/4",
            "unit": "cup",
            "notes": "60ml"
          },
          {
            "item": "Brown Sugar",
            "amount": "1",
            "unit": "tbsp",
            "notes": "14g"
          },
          {
            "item": "Black Pepper",
            "amount": "1",
            "unit": "tsp",
            "notes": "2g"
          },
          {
            "item": "Garlic Powder",
            "amount": "1",
            "unit": "tsp",
            "notes": "3g"
          },
          {
            "item": "Onion Powder",
            "amount": "1",
            "unit": "tsp",
            "notes": "2g"
          },
          {
            "item": "Red Pepper Flakes",
            "amount": "1/2",
            "unit": "tsp",
            "notes": "1g"
          }
        ]
      },
      {
        "variantId": "teriyaki-jerky",
        "name": "Teriyaki Jerky Recipe",
        "ingredients": [
          {
            "item": "Eye of round or top round beef",
            "amount": "2",
            "unit": "lb",
            "notes": "907g, trimmed of fat"
          },
          {
            "item": "Soy Sauce",
            "amount": "1/2",
            "unit": "cup",
            "notes": "120ml"
          },
          {
            "item": "Worcestershire Sauce",
            "amount": "1/4",
            "unit": "cup",
            "notes": "60ml"
          },
          {
            "item": "Sesame Oil",
            "amount": "2",
            "unit": "tsp",
            "notes": "10ml"
          },
          {
            "item": "Honey",
            "amount": "1",
            "unit": "tbsp",
            "notes": "21g"
          },
          {
            "item": "Dark Brown Sugar",
            "amount": "1",
            "unit": "tbsp",
            "notes": "14g"
          },
          {
            "item": "Smoked Paprika",
            "amount": "2",
            "unit": "tsp",
            "notes": "5g"
          },
          {
            "item": "Onion Powder",
            "amount": "1",
            "unit": "tsp",
            "notes": "2g"
          },
          {
            "item": "Garlic Powder",
            "amount": "1",
            "unit": "tsp",
            "notes": "3g"
          },
          {
            "item": "Black Pepper",
            "amount": "1",
            "unit": "tsp",
            "notes": "2g"
          },
          {
            "item": "Red Pepper Flakes",
            "amount": "1/2",
            "unit": "tsp",
            "notes": "1g"
          },
          {
            "item": "Cayenne Pepper",
            "amount": "1/2",
            "unit": "tsp",
            "notes": "1g"
          },
          {
            "item": "Ground Coriander",
            "amount": "1/2",
            "unit": "tsp",
            "notes": "1g"
          },
          {
            "item": "Ground Ginger",
            "amount": "1/2",
            "unit": "tsp",
            "notes": "1g"
          }
        ]
      },
      {
        "variantId": "sweet-spicy-jerky",
        "name": "Sweet & Spicy Jerky Recipe",
        "ingredients": [
          {
            "item": "Eye of round or top round beef",
            "amount": "2",
            "unit": "lb",
            "notes": "907g, trimmed of fat"
          },
          {
            "item": "Low sodium soy sauce",
            "amount": "1/3",
            "unit": "cup",
            "notes": "80ml"
          },
          {
            "item": "Brown sugar",
            "amount": "1/3",
            "unit": "cup",
            "notes": "73g packed"
          },
          {
            "item": "Worcestershire sauce",
            "amount": "2",
            "unit": "tbsp",
            "notes": "30ml"
          },
          {
            "item": "Balsamic vinegar",
            "amount": "2",
            "unit": "tbsp",
            "notes": "30ml"
          },
          {
            "item": "Fresh orange juice",
            "amount": "2",
            "unit": "tbsp",
            "notes": "30ml"
          },
          {
            "item": "Fresh grapefruit juice",
            "amount": "2",
            "unit": "tbsp",
            "notes": "30ml"
          },
          {
            "item": "Crushed red pepper",
            "amount": "1 1/4",
            "unit": "tsp",
            "notes": "3g"
          },
          {
            "item": "Onion powder",
            "amount": "1 1/4",
            "unit": "tsp",
            "notes": "3g"
          },
          {
            "item": "Garlic powder",
            "amount": "1 1/4",
            "unit": "tsp",
            "notes": "4g"
          },
          {
            "item": "Black pepper",
            "amount": "3/4",
            "unit": "tsp",
            "notes": "2g"
          },
          {
            "item": "Habanero pepper",
            "amount": "1/2",
            "notes": "fresh, finely chopped"
          },
          {
            "item": "Jalapeño pepper",
            "amount": "1/2",
            "notes": "fresh, finely chopped"
          }
        ]
      }
    ],
    "instructions": [
      "Freeze beef for 1 hour for easier slicing (look for $5/lb at grocery store).",
      "Trim all surface fat. Cut against the grain into 1/4 inch thick slices, then cut into strips.",
      "Choose one marinade recipe. Whisk all ingredients together until sugar dissolves.",
      "Add beef strips to marinade. Refrigerate for 6-16 hours, flipping/massaging bag every few hours.",
      "Remove beef from marinade and lay out on wire racks. Optionally add extra black pepper.",
      "Smoke at 180°F (82°C) for 4 hours until dark color and bends without breaking. (Dehydrator method: smoke 2 hours at 180°F (82°C), finish in dehydrator at 150°F (65°C) for 2-4 hours.)",
      "Cool completely. Store in refrigerator in airtight container."
    ],
    "equipment": [
      "Sharp knife or meat slicer",
      "Mixing bowls",
      "Gallon ziplock bags or vacuum sealer",
      "Wire racks",
      "Smoker (or dehydrator)",
      "Meat thermometer"
    ],
    "tips": [
      "Cutting against the grain makes jerky easier to bite and chew",
      "Consistent 1/4 inch thickness ensures even drying",
      "16 hours marinating gives maximum flavor, 6 hours is minimum",
      "Perfect jerky bends but doesn't snap in half",
      "Real smoke flavor is infinitely better than liquid smoke - never add liquid smoke",
      "Keeps 1-2 weeks in fridge, can freeze for up to 6 months"
    ],
    "notes": "All recipes scaled to 2 lbs of meat. No curing salt used because these are stored in fridge and eaten within days. Real smoke flavor from wood chips is infinitely better than liquid smoke."
  }
}
